<template>
    <el-dialog
        class="del-order"
        :visible.sync="delOrderVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="500px"
        title="Del Order"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form ref="delOrderForm" :model="delOrderForm" :rules="rules">
                <el-row>
                    <el-col :span="24">
                        <el-form-item
                            label="Order Num"
                            prop="content"
                            size="small"
                        >
                            <el-input
                                type="textarea"
                                v-model="delOrderForm.content"
                                :autosize="{ minRows: 8, maxRows: 10 }"
                                clearable
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >Save</el-button
            >
            <el-button size="small" @click="delOrderVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
export default {
    data() {
        return {
            delOrderForm: {
                content: "",
            },
            rules: {
                content: [
                    {
                        required: true,
                        message: "Please input SKU",
                    },
                ],
            },
        };
    },
    methods: {
        closeDialog() {
            this.$refs["delOrderForm"].clearValidate();
            this.$refs["delOrderForm"].resetFields();
            this.$emit("update:delOrderVisible", false);
            this.$parent[this.funcName] && this.$parent[this.funcName]();
        },
        save() {
            this.$refs["delOrderForm"].validate((valid) => {
                if (valid) {
                    cmofferApi
                        .orderCustomDelete(
                            {
                                ...this.delOrderForm,
                            },
                            "post"
                        )
                        .then((res) => {
                            if (res) {
                                this.$message.success(
                                    this.$i18n.locale == "zh"
                                        ? "操作成功"
                                        : "Success"
                                );
                                this.closeDialog();
                            }
                        });
                }
            });
        },
    },
    props: {
        delOrderVisible: Boolean,
        funcName: String,
    },
    watch: {
        delOrderVisible(val) {},
    },
};
</script>
<style lang="scss" scoped>
.set-private {
    .container {
        .el-select--small {
            width: 100%;
        }
    }
}
</style>
